import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageToggle = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'tr' ? 'en' : 'tr';
    i18n.changeLanguage(newLang);
    localStorage.setItem('language', newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-2 rounded-lg bg-slate-800/50 hover:bg-slate-700/50 transition-colors border border-slate-700"
     
      aria-label="Toggle Language"
    >
      <Globe size={18} className="text-blue-400" />
      <span className="text-sm font-medium text-white">
        {i18n.language === 'tr' ? 'EN' : 'TR'}
      </span>
    </button>
  );
};

export default LanguageToggle;
